import {useSelector} from 'react-redux';

import {selectIsMobileOnlyLayout} from '@/state/selectors/global';

const useIsMobileOnlyLayout = () => {
    const isMobileOnlyLayout = useSelector(selectIsMobileOnlyLayout);

    return isMobileOnlyLayout;
};

export default useIsMobileOnlyLayout;
